module.exports = __webpack_public_path__ + "img/visa.7d325fec.svg";